// * Note: Please collect location info & logtime of each and every API Requests

// import axios from 'axios';

import { API_CONFIG, PRODUCTION, UAT } from "common/config";
import { COMMON_JS } from "common/scripts";

const local = PRODUCTION === "false" && UAT === "false";
const LOCAL_PORT = "7007";

const trips = require("./trips.json");
const ldPoints = require("./loadingPoints.json");

export const TRANS_APIs = {
  manageStockAdjust: async (args = {}) => {
    let apiUrl = "/tr/v1/S0H1T2QHVS3ACULX";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.POST,
      args,
      false,
      local
    );
    return response;
  },
  getStockAdjusts: async (args = {}) => {
    let apiUrl = "/tr/v1/QK2EOEP4PQQWK8QD";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },

  manageStock: async (args = {}) => {
    let apiUrl = "/tr/v1/VMEQZ3JBF4021FQR";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.POST,
      args,
      false,
      local
    );
    return response;
  },
  getStocks: async (args = {}) => {
    let apiUrl = "/tr/v1/Q85J5LFDVRPMYIHM";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },

  managePayment: async (args = {}) => {
    let apiUrl = "/tr/v1/CAJX66V3K8NQ9AA7";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.POST,
      args,
      false,
      local
    );
    return response;
  },
  getPayments: async (args = {}) => {
    let apiUrl = "/tr/v1/U5KHSDPPCE7MQTDU";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },

  printOrder: async (args = {}) => {
    let apiUrl = "/pn/v1/PODKRUQP35PDJI8Q";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.POST,
      args,
      true,
      local
    );
    return response;
  },

  getDeliveryOrders: async (args = {}) => {
    let apiUrl = "/tr/v1/160B6502E62350OV";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },

  getStockloadInfo: async (args = {}) => {
    let apiUrl = "/tr/v1/840N2665S24137WI";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },

  getDriverStockloadInfo: async (args = {}) => {
    let apiUrl = "/tr/v1/570Z9115J43890PG";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },

  // Get Vehicle Route details
  getVehicleRoute: async (args = {}) => {
    let apiUrl = "/tr/v1/288S8142U58947PD";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },

  // Get Next customer details on Map
  getNextCustomerMap: async (args = {}) => {
    let apiUrl = "/tr/v1/623D3935K53996DU";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },

  // Add/Edit Stock Load
  manageStockLoad: async (args = {}) => {
    let apiUrl = "/tr/v1/760M5087V45028AX";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.POST,
      args,
      false,
      local
    );
    return response;
  },

  // Get Stock Load Details
  getStockLoad: async (args = {}) => {
    let apiUrl = "/tr/v1/692M4680C61934XI";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },

  // Add/Edit Stock Load Challan
  manageChallan: async (args = {}) => {
    let apiUrl = "/tr/v1/187H1122J35909WJ";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.POST,
      args,
      false,
      local
    );
    return response;
  },

  deleteOrderItem: async (args = {}) => {
    let resObj: any = {};
    resObj = {
      status: 200,
    };
    return resObj;
  },

  // getVehicleDriver: async (args = {}) => {
  //   const response = await COMMON_JS.callApi(
  //     '/v1/vehicle/driver',
  //     API_CONFIG.METHODS.GET,
  //     args,
  //     accessToken,
  //   );
  //   return response;
  // },
  //TODO: Please Update this API..
  getTrips: async (args: any = {}) => {
    let resObj: any = {};
    let apiUrl = "/ge/v1/WJPKYM8NEFH341AY";
    if (local) {
      apiUrl = API_CONFIG.API_URL + LOCAL_PORT + apiUrl;
    }

    resObj = trips;
    return resObj;
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },
  //TODO: Please Update this API..
  getLoadingPtComments: async (args: any = {}) => {
    let resObj: any = {};
    let apiUrl = "/ge/v1/WJPKYM8NEFH341AY";
    if (local) {
      apiUrl = API_CONFIG.API_URL + LOCAL_PORT + apiUrl;
    }

    resObj = ldPoints;
    return resObj;
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },

  manageCreditNote: async (args = {}) => {
    let apiUrl = "/tr/v1/5ZN9KNZ3NVCL97R9";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.POST,
      args,
      false,
      local
    );
    return response;
  },
  getCreditNote: async (args = {}) => {
    let resObj: any = {};
    resObj = {
      status: 200,
      response: {
        records: [
          {
            id: " 1",
            refNumber: "123",
            amount: "1111",
            remarks: "remarks",
            sapReference: "1234",
            approvalAmount: "1112",
            approvalRemarks: "Approval Remarks",
            files: [],
          },
          {
            id: " 2",
            refNumber: "456",
            amount: "2000",
            remarks: "test2",
            sapReference: "4444",
            approvalAmount: "2000",
            approvalRemarks: "Approval Remarks2",
            files: [],
          },
        ],
      },
    };
    return resObj;

    let apiUrl = "/tr/v1/DO6Z84KHQC7Z9RJQ";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },

  manageDmsInvoices: async (args = {}) => {
    let apiUrl = "/tr/v1/6D15CYM9ZA2TP32U";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.POST,
      args,
      false,
      local
    );
    return response;
  },

  manageDmsInvoice: async (args = {}) => {
    let apiUrl = "/tr/v1/0ENO629836U0X7RM";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.POST,
      args,
      false,
      local
    );
    return response;
  },

  getDmsInvoices: async (args = {}) => {
    let apiUrl = "/tr/v1/RPG0MVQIH4QB6QNF";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":" + LOCAL_PORT + apiUrl;
    }
    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.GET,
      args,
      false,
      local
    );
    return response;
  },
};
